// eslint-disable-next-line import/no-extraneous-dependencies
import { getContentfulTargetingIds } from '@thd-olt-component-react/personalization-utils';

const hasIds = ({ mboxes, innervateTags }) => {

  return (mboxes?.length > 0) || (innervateTags?.length > 0);
};

export const isReadyUtil = ({
  contentfulComponents,
  serverLayouts = {},
  clientLayouts = {},
  customerType,
}) => {
  let mboxes = [];
  let innervateTags = [];
  let isReady = false;
  const combinedDataPresent = !!serverLayouts.data && !!clientLayouts.data;

  if (combinedDataPresent || (serverLayouts.data && customerType === 'b2c-guest')) {
    if (contentfulComponents) {
      const targetingIds = getContentfulTargetingIds({
        content: contentfulComponents,
        containerKeys: {
          SpotlightContainer: 'spotlightList',
          BentoHero: 'secondBay.components',
        },
      });

      isReady = hasIds({ ...targetingIds }) || false;

      if (customerType === 'b2c-guest') {
        isReady = contentfulComponents ? hasIds({ ...targetingIds }) : false;
      }

      mboxes = targetingIds.mboxes;
      innervateTags = targetingIds.innervateTags;
    }
  }

  return {
    mboxes,
    innervateTags,
    isReady,
  };
};
